const moveNotifyButtonsInNewCards = () => {
  const cardsWrappersInfoSelector = document.querySelectorAll('.card-product-new__info');

  cardsWrappersInfoSelector.forEach((cardWrapper) => {
    const notifyButton = cardWrapper.querySelector('.restock-rocket-button-collection');
    const buttonsWrapper = cardWrapper.querySelector('.card-product-new__buttons-wrapper');

    if (!notifyButton || !buttonsWrapper) return;

    if (buttonsWrapper.contains(notifyButton)) return;

    buttonsWrapper.appendChild(notifyButton);
  });
};

const moveNotifyByttonsInHorizontalNewCards = () => { 
  const cardWrapperInfoSelector = document.querySelectorAll('.card-product-horizontal-new__information');

  cardWrapperInfoSelector.forEach((cardWrapper) => {
    const notifyButton = cardWrapper.querySelector('.restock-rocket-button-collection');
    const buttonsWrapper = cardWrapper.querySelector('.card-product-horizontal-new__buttons-wrapper');

    if (!notifyButton || !buttonsWrapper) return;
    
    if (buttonsWrapper.contains(notifyButton)) return;

    buttonsWrapper.appendChild(notifyButton);
  });
};

// There is an event, but it fires asynchronously, so I use an observer instead.
document.addEventListener('DOMContentLoaded', () => {
  moveNotifyButtonsInNewCards();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (
          node.matches('.restock-rocket-button-collection') ||
          node.querySelector('.restock-rocket-button-collection')
        ) {
          moveNotifyButtonsInNewCards();
          moveNotifyByttonsInHorizontalNewCards();
          observer.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
